import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/protected-route";
import { InspectionChecklistDetailPage } from "@/components/inventory/InspectionChecklistDetailPage";

export const Route = createFileRoute("/admin/_layout/inventory/inspection-checklists_/$id")({
  component: InspectionChecklistDetailRoute,
});

function InspectionChecklistDetailRoute() {
  const { id } = Route.useParams();
  // Same gate as the list page: InspectionChecklistViewSet's read_permission
  // ("inventory.stock.view") covers retrieve too, with no
  // degrade-to-own-rows fallback.
  return (
    <ProtectedRoute requiredPermission="inventory.stock.view">
      <InspectionChecklistDetailPage checklistId={id} />
    </ProtectedRoute>
  );
}
